"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OTPErrorsType = exports.SignatureKeyErrorsType = void 0;
var SignatureKeyErrorsType;
(function (SignatureKeyErrorsType) {
    SignatureKeyErrorsType["KO_USER_ERROR"] = "KO_USER_ERROR";
    SignatureKeyErrorsType["KO_TECHNICAL_ERROR"] = "KO_TECHNICAL_ERROR";
})(SignatureKeyErrorsType || (exports.SignatureKeyErrorsType = SignatureKeyErrorsType = {}));
var OTPErrorsType;
(function (OTPErrorsType) {
    OTPErrorsType["KO_USER_ERROR"] = "KO_USER_ERROR";
    OTPErrorsType["KO_TECHNICAL_ERROR"] = "KO_TECHNICAL_ERROR";
    OTPErrorsType["KO_OTP_LIMIT"] = "KO_OTP_LIMIT";
})(OTPErrorsType || (exports.OTPErrorsType = OTPErrorsType = {}));
//# sourceMappingURL=usdInterface.js.map